import React, { ComponentProps, ReactNode } from 'react';
import { Square } from '@grubhubprod/gh-cookbook-react/dist';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';
import {
  getPageSectionBorderRadius,
  getPageSectionDimension,
  PageSectionBorderRadius,
} from 'src/components/selfService/layout/PageSection/pageSectionUtils/pageSectionUtils';

export interface PageSectionProps {
  bg?: ComponentProps<typeof Square>['bg'];
  borderRadius?: PageSectionBorderRadius;
  dataTestId?: string;
  fullHeight?: boolean;
  children: ReactNode;
}

export const PageSection: React.FC<PageSectionProps> = ({
  children,
  bg = 'untintedBackground',
  borderRadius,
  dataTestId,
  fullHeight = false,
}) => {
  const { isLoading: isBalanceUiLoading, value: isBalanceUiEnabled } =
    useFeatureFlag(FeatureFlag.ENABLE_BALANCE_UI);

  const appliedBorderRadius = getPageSectionBorderRadius(
    isBalanceUiEnabled,
    isBalanceUiLoading,
    borderRadius
  );
  const appliedDimension = getPageSectionDimension(
    isBalanceUiEnabled,
    isBalanceUiLoading
  );
  const appliedHeight = fullHeight ? '100%' : undefined;

  return (
    <Square
      bg={bg}
      borderRadius={appliedBorderRadius}
      data-testid={dataTestId}
      dimension={appliedDimension}
      height={appliedHeight}
      inset="lg"
    >
      {children}
    </Square>
  );
};
